import { params, executeSearchUrl, displayResults } from '../search-main';
let sortFields: RadioNodeList | null;
let sortContainer: HTMLDivElement | null;
let clearButton: HTMLButtonElement | null;
let sortToggleButton: HTMLButtonElement | null;
let sortByLabel: HTMLSpanElement | null;
const sortByLabelDefault: string = 'Sort by';
const endDateOption: string = "enddate";

document.addEventListener('DOMContentLoaded', () => {
    sortFields = document.getElementsByName('sort-item') as RadioNodeList;
    sortContainer = document.querySelector<HTMLDivElement>('#sort-filter-container');
    clearButton = document.querySelector<HTMLButtonElement>('#clear-sort-item');
    sortToggleButton = document.querySelector<HTMLButtonElement>('#sort-toggle');
    sortByLabel = document.querySelector<HTMLSpanElement>('#sort-by-label');
    sortFields?.forEach(x => x.addEventListener('change', sortFieldChanged));
    clearButton?.addEventListener('click', clearSortFilter);
});

/**
 * Sets the values for the SortField and SortDirection selects
 * as well as shows or hides the component
 * @constructor
 * @param {boolean} show - Indicates whether to show or hide sort container
 */
export function displaySortFilter(show: boolean = true) {
    if (!sortContainer || !sortFields) { return; }

    if (params.SortField) {
        sortFields.forEach((item) => {
            if (item.value === params.SortField) {
                item.checked = true;
                if (sortByLabel) {
                    sortByLabel.innerText = item.dataset.label ?? sortByLabelDefault;
                }
                setSortDirection();
            }
        });
    }

    if (show) {
        sortContainer.classList.remove("!hidden");
    }
    else {
        sortContainer.classList.add("!hidden");
    }
}

function sortFieldChanged() {
    if (!sortFields || !sortByLabel) { return; }

    params.Page = "1";
    let sortFieldValue = "";
    let sortFieldDisplay = sortByLabelDefault;
    sortFields.forEach((item) => {
        if (item.checked) {
            sortFieldValue = item.value;
            sortFieldDisplay = item.dataset.label ?? sortByLabelDefault;
        }
    });
    params.SortField = sortFieldValue;
    setSortDirection();
    displayResults(executeSearchUrl);
    sortByLabel.innerText = sortFieldDisplay;
    sortToggleButton?.click();
    sortToggleButton?.focus();
}

function clearSortFilter() {
    if (!sortFields || !sortByLabel) { return; }

    params.Page = "1";
    params.SortField = "";
    params.SortDirection = "";
    sortFields.forEach((item) => {
        item.checked = false;
    });
    displayResults(executeSearchUrl);
    sortByLabel.innerText = sortByLabelDefault;
    sortToggleButton?.click();
    sortToggleButton?.focus();
}

function setSortDirection() {
    if (params.SortField === endDateOption) {
        params.SortDirection = "asc";
    } else {
        params.SortDirection = "desc";
    }
}
